export default (state, action) => {
    switch (action.type) {
        case 'CLICKED':
            return {
                ...state,
                clicked: state.clicked + 1,
            };
        case 'SET_LOCATION':
            return {
                ...state,
                user: {
                    ...state.user,
                    location: action.location,
                },
            };
        case 'SET_USER':
            return {
                ...state,
                user: action.user,
            };
        case 'UPDATE_WORKDAYS':
            return {
                ...state,
                user: {
                    ...state.user,
                    workDays: action.workDays
                }
            }
        default:
            return state;
    };
};
